import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatCurrencyAmount, setReduxFields } from '../../utils/library';
import Dropdown from 'semantic-ui-react/dist/commonjs/modules/Dropdown';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { change, Field } from 'redux-form';

import { FORMNAME_MULTI_TRANSACTIONS } from '../../utils/constants';
import { getPaymentMethodIcon } from '../../utils/templates/payment-method';
import './transaction-modal-corporate.scss';
import MultipleTransactionInfoContent from '../multiple-transaction-info-content/MultipleTransactionInfoContent';
import COLORS from '../../common/styles/color-pallete';
import CommonButton from '../common-button/CommonButton';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { INFO_TIMELINE_ICON } from '@Images';

const TextStyle = {
  text: `font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 26px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.black};
  padding-left: 40px !important;
  align-self:end;`
};

const ContainerBorder = styled.div`
  border-top: solid 2px ${COLORS.textLightGrey};
  border-bottom: solid 2px ${COLORS.textLightGrey};
  grid-column: span 2;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 26px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  .close-btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;

const Title = styled.div`
  ${TextStyle.text}
  ${({ alignEnd }) => (alignEnd ? `width:100%; text-align: end;` : null)}
  ${({ padding }) => (padding ? `padding: ${padding};` : null)}
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 500)};
`;

const SubHeader = styled.p`
  font-size: 11.2px;
  color: #a7a7a7;
`;

const TranscationContianer = styled.div`
  display: grid;
  grid-template: repeat(4, 1fr) / 2fr 1fr;
  border-radius: 20px;
  border: solid 0.8px #c8c8c8;
  grid-row-gap: 10px;
  justify-items: start;
  width: 597.1px;
  height: 300px;
  border-radius: 15.5px;
  border: solid 0.6px #c8c8c8;
  margin-top: 14px;
  padding: 20px 20px 20px 0px;
`;
const Header = styled(Title)`
  white-space: nowrap;
  color: ${COLORS.black};
  font-size: ${({ size }) => (size ? size : '22.4px')};
  align-items: center;
  ${({ alignEnd }) => (alignEnd ? `width:100%; text-align: end;` : null)}
  ${({ padding }) => (padding ? `padding: ${padding};` : null)}
    padding-top:${({ paddingTop }) => (paddingTop ? paddingTop : 0)};
`;
const PaymentMethodDropdown = styled.div`
  grid-row: 2 / span 2;
  width: 320px;
  height: 58.7px;
  padding-left: 40px !important;
  align-self: center;
  &.title {
    font-size: 16px;
    color: #202859;
  }
`;
const Values = styled(Title)`
  color: ${({ color }) => (color ? color : '#747474')};
  font-size: 19.2px;
  ${({ alignEnd }) => (alignEnd ? `width:100%; text-align: end;` : null)}

  ${({ padding }) => (padding ? `padding: ${padding};` : null)}
`;
const AchValues = styled(Values)`
  grid-row: 2 / span 2;
  align-self: center;
  ${({ alignEnd }) => (alignEnd ? `width:100%; text-align: end;` : null)}
  ${({ padding }) => (padding ? `padding: ${padding};` : null)}
`;

const GridRrow = styled.div`
  display: grid;
  padding: 30px 0;
  grid-row-gap: 10px;
  justify-items: start;
`;

const DropdownSelectedItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  justify-content: space-between;
  .title {
    color: ${COLORS.black};
    font-size: 12.4px;
    margin-bottom: 5px;
  }
  .subtitle {
    font-size: 8.5px;
    color: ${COLORS.textLightGrey};
  }
  .dropdown.icon {
    display: none;
    color: #00a9df !important;
  }
`;
function renderPaymentMethodItems(selected) {
  return ({ key, value, fee_notes, icon_url, display_name }, index) => ({
    key,
    value,
    text: (
      <DropdownSelectedItem key={index}>
        <div className="title">{display_name}</div>
        <div className="subtitle">{fee_notes}</div>
      </DropdownSelectedItem>
    ),
    content: (
      <div className="option" key={index}>
        <img
          src={getPaymentMethodIcon(icon_url, selected === value)}
          alt={fee_notes}
          className="icon"
        />
        <div className="title">{display_name}</div>
        <div className="subtitle">{fee_notes}</div>
      </div>
    )
  });
}
export function TransactionsDetailCorporate(props) {
  const destinationReceivedAmount = formatCurrencyAmount(props.destination_amount);
  const { instarem_bank_account_id, dispatch, bankAccountOptions, net_source_amount } = props;
  const discount = (props.coupon_amount || 0) + (props.redeemed_instapoints_amount || 0);
  const total_fee_amount =
    (props.transactionDetails && props.transactionDetails.total_fee_amount) ||
    (props.transactionDetails.transaction_config &&
      props.transactionDetails.transaction_config.total_fee_amount);
  return (
    <Container>
      <Title fontWeight={600}>Transaction Details</Title>
      <TranscationContianer>
        <Header>
          You Send <SubHeader>Includes Fee With</SubHeader>
        </Header>
        <Header
          alignEnd
          padding={'0px 26px 0px 0px'}
        >{`${props.gross_source_amount} ${props.source_currency}`}</Header>

        <PaymentMethodDropdown>
          <Field
            name="instarem_bank_account_id"
            component={({ input: { value, onBlur } }) => (
              <Dropdown
                value={value}
                options={bankAccountOptions.map(renderPaymentMethodItems(instarem_bank_account_id))}
                placeholder="Select Transfer Method"
                className="payment-method"
                onBlur={onBlur}
                onChange={(e, { value: instarem_bank_account_id }) =>
                  setReduxFields(dispatch, change, FORMNAME_MULTI_TRANSACTIONS, {
                    instarem_bank_account_id
                  })
                }
              />
            )}
          />
        </PaymentMethodDropdown>
        <AchValues
          alignEnd
          padding={'0px 26px 0px 0px'}
        >{`${total_fee_amount} ${props.source_currency}`}</AchValues>

        <Values color={'#747474'}>Conversion Amount</Values>
        <Values color={'#747474'} alignEnd padding={'0px 8px 0px 0px'}>
          {`${props.gross_source_amount - total_fee_amount} ${props.source_currency}`}
          <Popup
            trigger={
              <img
                src={INFO_TIMELINE_ICON}
                alt="info icon"
                className="icon-info"
                height="15px"
                width="15px"
              />
            }
            content={<MultipleTransactionInfoContent config={props.sourceCurrencyInfoConfig} />}
            className="currency-convertor-popup"
            hideOnScroll={false}
            size="huge"
            position="top right"
          />
        </Values>

        <Values color={'#747474'}>
          {`Conversion Rate ${props.source_currency}/${props.destination_currency}`}{' '}
        </Values>
        <Values color={'#747474'} alignEnd padding={'0px 26px 0px 0px'}>
          {props.instarem_fx_rate}
        </Values>

        <Header>Recipient Receives</Header>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <Header size={'19px'} padding={'0px 0px 0px 51px !important'}>
            {`${destinationReceivedAmount} ${props.destination_currency}`}
          </Header>
          <Popup
            trigger={
              <img
                src={INFO_TIMELINE_ICON}
                alt="info icon"
                className="icon-info"
                height="15px"
                width="15px"
              />
            }
            content={
              <MultipleTransactionInfoContent
                config={props.destinationCurrencyInfoConfig}
                viewFor={'destination'}
              />
            }
            className="currency-convertor-popup"
            hideOnScroll={false}
            size="huge"
            position="top right"
          />
        </div>
      </TranscationContianer>

      <Header paddingTop={'20px'}>Amount Payable</Header>
      <GridRrow>
        <Values color={'#747474'}>You Send</Values>
        <Values
          alignEnd
          padding={'0px 26px 0px 0px'}
        >{`${props.gross_source_amount} ${props.source_currency}`}</Values>

        <Values color={'#747474'}>Coupon Code / Instapoints</Values>
        <Values color={'#747474'} alignEnd padding={'0px 26px 0px 0px'}>
          {discount > 0 ? '-' : ''}
          {discount}
        </Values>

        <ContainerBorder>
          <Title fontWeight={600}>You Pay Only</Title>
          <Title fontWeight={600}>{net_source_amount}</Title>
        </ContainerBorder>
      </GridRrow>
      <div className="close-btn-container">
        <CommonButton
          onClick={() => props.toggleTransactionsModal()}
          text="Close"
          width={205}
          height={40}
        />
      </div>
    </Container>
  );
}

TransactionsDetailCorporate.propTypes = {
  net_source_amount: PropTypes.any,
  destination_amount: PropTypes.any,
  gross_source_amount: PropTypes.any,
  source_currency: PropTypes.string,
  transaction_fee_amount: PropTypes.any,
  net_of_fee_amount: PropTypes.any,
  instarem_fx_rate: PropTypes.any,
  destination_currency: PropTypes.any,
  coupon_amount: PropTypes.any,
  bankAccountOptions: PropTypes.any,
  instarem_bank_account_id: PropTypes.any,
  dispatch: PropTypes.func,
  toggleTransactionsModal: PropTypes.func,
  redeemed_instapoints_amount: PropTypes.any,
  is_corporate_case: PropTypes.bool,
  destinationCurrencyInfoConfig: PropTypes.any,
  sourceCurrencyInfoConfig: PropTypes.any,
  transactionDetails: PropTypes.object
};

TransactionsDetailCorporate.defaultProps = {
  source_currency: 'usd',
  gross_source_amount: 0,
  destination_currency: 'INR',
  destination_amount: 0,
  coupon_amount: 0,
  redeemed_instapoints_amount: 0,
  net_of_fee_amount: 0,
  net_source_amount: 0,
  instarem_fx_rate: 0,
  transaction_fee_amount: 0,
  payment_method_fee_amount: 0,
  net_tax_amount: 0,
  instarem_bank_account_id: '',
  is_corporate_case: false
};
